import { render, staticRenderFns } from "./LongStayDetails_Accommodation.vue?vue&type=template&id=2562e750&"
import script from "./LongStayDetails_Accommodation.vue?vue&type=script&lang=js&"
export * from "./LongStayDetails_Accommodation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports